import { motion } from "framer-motion";
import { Phone, MapPin, CheckCircle2 } from "lucide-react";
import { formatPhoneOnInput, validateGhanaPhoneNumber } from "../../../utils/formValidators";
import { useState } from "react";

export default function Step3ContactDetails({ formData, setFormData, errors }) {
  const [phoneValidation, setPhoneValidation] = useState({ contactNumber: null });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handlePhoneChange = (field, value) => {
    const formatted = formatPhoneOnInput(value);
    handleChange(field, formatted);
    const validation = validateGhanaPhoneNumber(formatted.replace(/\s/g, ""));
    setPhoneValidation((prev) => ({ ...prev, [field]: validation.isValid ? "valid" : null }));
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
      className="p-6 bg-white rounded-xl border border-gray-200 shadow-sm sm:p-8"
    >
      <div className="flex gap-3 items-center mb-8">
        <div className="flex justify-center items-center w-10 h-10 text-white bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg shadow-md">
          <Phone size={20} />
        </div>
        <h2 className="text-2xl font-bold text-gray-900">Contact Details</h2>
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <div>
          <label className="flex gap-2 items-center mb-2 text-sm font-semibold text-gray-700">
            <Phone size={16} className="text-orange-600" />
            Contact Number (include country code) <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <input
              type="tel"
              value={formData.contactNumber || ""}
              onChange={(e) => handlePhoneChange("contactNumber", e.target.value)}
              className={`w-full px-4 py-3 pr-10 text-gray-900 bg-white rounded-lg border transition-all outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 ${
                errors?.contactNumber
                  ? "border-red-300 bg-red-50"
                  : phoneValidation.contactNumber === "valid"
                  ? "border-green-300 bg-green-50"
                  : "border-gray-300 hover:border-gray-400"
              }`}
              placeholder="0241234567 or 233241234567"
            />
            {phoneValidation.contactNumber === "valid" && (
              <CheckCircle2 className="absolute top-3.5 right-3 text-green-500" size={20} />
            )}
          </div>
          <p className="mt-1 text-xs text-gray-500">Format: 233XXXXXXXXX (12 digits) or 0XXXXXXXXX (10 digits)</p>
          {errors?.contactNumber && <p className="mt-1 text-sm text-red-500">{errors.contactNumber}</p>}
        </div>
        <div>
          <label className="flex gap-2 items-center mb-2 text-sm font-semibold text-gray-700">
            <MapPin size={16} className="text-orange-600" />
            Address <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={formData.address || ""}
            onChange={(e) => handleChange("address", e.target.value)}
            className={`w-full px-4 py-3 text-gray-900 bg-white rounded-lg border transition-all outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 ${
              errors?.address ? "border-red-300 bg-red-50" : "border-gray-300 hover:border-gray-400"
            }`}
            placeholder="Enter your address"
          />
          {errors?.address && <p className="mt-1 text-sm text-red-500">{errors.address}</p>}
        </div>
      </div>
    </motion.div>
  );
}
